import {DatasetDataInfoResponse} from "api/model/dataset/DatasetDataInfoResponse";
import {InstantDoubleValue} from "api/model/dataset/InstantDoubleValue";

export const calculateYAxisRangeValues = (array: DatasetDataInfoResponse[]) => {
    return array.map(dataset => {
        const data = dataset.data;

        if (data.length < 2) {
            return {
                identifier: dataset.identifier,
                yAxisMax: 0,
                yAxisMin: 0
            }
        }

        const quartile = (arr: InstantDoubleValue[], q: number) => {
            const sorted = [...arr].sort((a, b) => a.value - b.value);
            const pos = (sorted.length - 1) * q;
            const base = Math.floor(pos);
            const rest = pos - base;
            if (sorted[base + 1].value === undefined) {
                return sorted[base].value;
            } else {
                return sorted[base].value + rest * (sorted[base + 1].value - sorted[base].value);
            }
        };

        const Q1 = quartile(data, 0.10);
        const Q3 = quartile(data, 0.90);
        const IQR = Q3 - Q1;

        const noOutliers: InstantDoubleValue[] = []
        data.map(obj => {
            if(obj.value > (Q3 + (1.5 * IQR)) || obj.value < (Q1 - (1.5 * IQR))) {
            }
            else {
                noOutliers.push(obj);
            }
        })

        const dataValues: Array<number> = noOutliers.map(datapoint => datapoint.value);

        // using reduce instead of Math.max(...dataValues)/Math.min(...dataValues) to avoid stack overflow in chrome
        const max = dataValues.reduce((a, b) => Math.max(a, b));
        const min = dataValues.reduce((a, b) => Math.min(a, b));

        if (dataValues.length > 0) {
            return {
                identifier: dataset.identifier,
                yAxisMax: Math.ceil(max),
                yAxisMin: Math.floor(min)
            }
        }
        return dataset;
    });
}